<script setup lang="ts">
import { computed } from 'vue'
import upcoming from '@/assets/images/itinerary/upcoming.png'
import inProgress from '@/assets/images/itinerary/inprogress.png'
import completed from '@/assets/images/itinerary/completed.png'
import last from '@/assets/images/itinerary/last.png'

const props = defineProps<{
  isLastStop?: boolean
  isInProgress?: boolean
  isCompleted?: boolean
  isModified?: boolean
}>()

const icon = computed(() => {
  if (props.isLastStop) {
    return last
  } else if (props.isInProgress) {
    return inProgress
  } else if (props.isCompleted) {
    return completed
  }
  return upcoming
})

const iconAltText = computed(() => {
  if (props.isLastStop) {
    return 'Last Stop Icon'
  } else if (props.isInProgress) {
    return 'In Progress Stop Icon'
  } else if (props.isCompleted) {
    return 'Completed Stop Icon'
  }
  return 'Upcoming Stop Icon'
})
</script>

<template>
  <div class="timeline-stop__wrapper">
    <div
      class="timeline-stop__icon"
      :class="{ 'timeline-stop__icon--border': !isLastStop }"
    >
      <img :src="icon" :alt="iconAltText" width="16" height="16" />
    </div>
    <div
      class="timeline-stop__content"
      :class="{ 'timeline-stop__modified': isModified }"
    >
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.timeline-stop__wrapper {
  display: flex;
  background: white;
}

.timeline-stop__icon {
  min-width: 20px;
  position: relative;

  img {
    z-index: 5;
    position: relative;
  }
}

.timeline-stop__icon--border::after {
  content: '';
  position: absolute;
  left: 7px;
  top: 7px;
  height: calc(100% - 7px);
  border-left: 2px dashed var(--cu-gray-300, #ccc);
}

.timeline-stop__content {
  font-family: var(--font-family-default);
  font-weight: 400;
  font-size: 1rem;
  margin: 0 0 24px 12px;
  padding: 4px 8px;
  flex-grow: 1;

  h4 {
    font-size: 1rem;
    line-height: 1;
    font-weight: 600;
    margin: 0;
  }
}

.timeline-stop__modified {
  background: var(--cu-blue-gray-50);
  border-radius: 4px;
}
</style>
